// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"QZ-z","tooltip":"RZ-z","tooltipContent":"SZ-z","orderStatusWrapper":"TZ-z"};